import { isShortlisted, toggleShortlist } from '../../_shared/shortlist';

document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll<HTMLButtonElement>('.wp-block-ocean-property-shortlist');

	buttons.forEach((button) => {
		const propertyId = parseInt(button.dataset.propertyId || '0', 10);
		if (!propertyId)
			{
			return;
			}

		const item = {
			id: propertyId,
			title: button.dataset.title || '',
			thumbnail: button.dataset.thumbnail || '',
			permalink: button.dataset.permalink || '',
			};

		const label = button.querySelector('.property-shortlist__label');

		// "Compact" block style (jrx/variations/src/index.ts) -- one-word
		// labels for tight spots such as the sticky mobile bar. The action is
		// still announced properly either way: aria-pressed carries the state,
		// so the visible text is free to be this short.
		const compact = button.classList.contains('is-style-compact');

		const applyState = (active: boolean) =>
			{
			button.setAttribute('aria-pressed', active ? 'true' : 'false');
			button.classList.toggle('is-active', active);
			if (label)
				{
				if (compact)
					{
					label.textContent = active ? 'Shortlisted' : 'Shortlist';
					}
				else
					{
					label.textContent = active ? 'Remove from shortlist' : 'Add to shortlist';
					}
				}
			};

		applyState(isShortlisted(propertyId));
		button.classList.add('is-ready');

		button.addEventListener('click', () => {
			applyState(toggleShortlist(item));
		});
	});
});
